var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 91,
    viewBox: "0 0 110 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.4185 53.0544L44.0035 90.9832L33.1526 90.9832L46.8573 53.0544L17.7767 53.0544L8.73787 67.2777L0.599644 67.2777L6.02513 45.9428L0.599646 24.6078L8.73787 24.6078L17.7822 38.8311L46.8628 38.8311L33.1526 0.902341L44.0035 0.902341L71.4185 38.8311L100.971 38.8311C103.13 38.8311 105.2 39.5804 106.726 40.9141C108.252 42.2478 109.109 44.0567 109.109 45.9428C109.109 47.8289 108.252 49.6378 106.726 50.9715C105.2 52.3052 103.13 53.0544 100.971 53.0544L71.4185 53.0544Z",
    fill: "#52C1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlight);
export default __webpack_public_path__ + "static/media/iconFlight.2348691dc626d3df22ae7dbe333fbd75.svg";
export { ForwardRef as ReactComponent };